export default function FooterSection() {
  return (
    <footer className="py-8 sm:py-10 md:py-12 px-4 sm:px-6 border-t border-border/30">
      <div className="max-w-7xl mx-auto">
        
        {/* Contact Email */}
        <div className="text-center mb-4 sm:mb-6">
          <p className="mono-data text-xs sm:text-sm text-foreground/70">
            Questions? Contact us at{' '}
            <a href="mailto:hello@lume001.online" className="text-primary hover:underline break-all">
              hello@lume001.online
            </a>
          </p>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="mono-data text-xs text-foreground/50">
            © 2026 LUME001. All rights reserved. Batch 001: Limited to 1,000 units.
          </p>
        </div>

      </div>
    </footer>
  )
}